import {
  CheckPriceProps,
  useExistingProductState,
} from "Components/Features/CheckPrice";
import React, { useEffect } from "react";
import {
  PATH,
  TRAILER_DETAILS_STEP,
  TRAILER_INTRO_STEP,
  TRAILER_PRICE_STEP,
  TRAILER_STEPS,
} from "./";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { ActiveStep } from "Components/ActiveStep";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { setCheckPriceProducts } from "Store/analytics/analyticsSlice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { useProductTexts } from "Store/texts/hooks";
import { useDispatch } from "react-redux";
import { Route } from "react-router";
import { TrailerProductDetails } from "./ProductDetails/TrailerProductDetails";
import { TrailerProductIntro } from "./ProductIntro/TrailerProductIntro";
import { TrailerProductPrice } from "./ProductPrice/TrailerProductPrice";
import { TrailerTexts } from "./trailerInterface";

export const TrailerCheckPrice = (
  props: CheckPriceProps,
): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  const { updatePriceRequest } = props;
  const [texts, lang] = useProductTexts<TrailerTexts>(
    INSURANCE_NAME_VALUE.TRAILER.toLowerCase(),
  );
  useExistingProductState(INSURANCE_NAME_VALUE.TRAILER);
  useEffect(() => {
    dispatch(setCheckPriceProducts([INSURANCE_NAME_VALUE.TRAILER]));
  }, []);

  return (
    <ProductTile
      productName={getText("insuranceproduct.trailer.name")}
      productBackendName={ProductBackendName.TRAILER}
      productPath={PATH}
      productSteps={TRAILER_STEPS}
      title={texts.title[lang]}
      iconName={Icons.TRAILER}
    >
      <Route
        exact
        path={`${PATH}/${TRAILER_INTRO_STEP.id}`}
        render={() => (
          <ActiveStep>
            <TrailerProductIntro texts={texts} lang={lang} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${TRAILER_DETAILS_STEP.id}`}
        render={() => (
          <ActiveStep>
            <TrailerProductDetails
              texts={texts}
              lang={lang}
              updatePriceRequest={updatePriceRequest}
            />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${TRAILER_PRICE_STEP.id}`}
        render={() => (
          <ActiveStep>
            <TrailerProductPrice texts={texts} lang={lang} />
          </ActiveStep>
        )}
      />
    </ProductTile>
  );
};
